import React from "react";
import { Button } from "reactstrap";
import { useTranslation } from 'react-i18next';
import CustomTooltip from "../Tooltip";

const Index = ({ title, width = 22, height = 22, padding = 6, ...other }) => {
  const { t } = useTranslation(['configure']);

  return (
    <CustomTooltip title={title || t('Delete')}>
      <Button type="primary" color="danger" style={{ padding: padding }} {...other}>
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 18C2.45 18 1.979 17.804 1.587 17.412C1.195 17.02 0.999333 16.5493 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.804 17.021 14.412 17.413C14.02 17.805 13.5493 18.0007 13 18H3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
            fill="white"
          />
        </svg>
      </Button>
    </CustomTooltip>
  );
};

export default Index;
